module.exports = __webpack_public_path__ + "assets/singing.jpg?5add146d6fb4fe031cf01e38a5707c8b";